import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=610cf27a&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=610cf27a&prod&scoped=true&lang=css"
import style1 from "./UserManagement.vue?vue&type=style&index=1&id=610cf27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610cf27a",
  null
  
)

export default component.exports